import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgbPaginationModule } from '@ng-bitapp/pagination';
import { NgSelectConfig, NgSelectModule } from '@ng-select/ng-select';
import { FlatpickrModule } from 'angularx-flatpickr';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import localeItExtra from '@angular/common/locales/extra/it';
import { NgbMessagesModule } from '@bitapp-srl/ngb-messages';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { interceptorProviders } from './shared/interceptors/interceptors';
import { LoginComponent } from './shared/components/login/login.component';
import { SsoComponent } from './shared/components/sso/sso.component';
import { MaintenanceComponent } from './shared/components/maintenance/maintenance.component';
import { QuillModule } from 'ngx-quill';
import { CookieService } from 'ngx-cookie-service';
import { EnvServiceProvider } from './env.service.provider';
import { ApiModule, Configuration, ConfigurationParameters } from 'src/openapi';
import { RouteReuseStrategy } from '@angular/router';
import { CustomRouteReuseStrategy } from './customRouteReuseStrategy';
import { ConfirmComponent } from './components/confirm/confirm.component';
import { MatDialogModule } from '@angular/material/dialog';
import { DialogService } from './services/dialog.service';
import { VideoPlayerModule } from './generic/video-player/video-player.module';

registerLocaleData(localeIt, 'it-IT', localeItExtra);

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

export function apiConfiguration(): Configuration {
  const params: ConfigurationParameters = {
    basePath: window['__env'].API_BASE_PATH,
  };
  return new Configuration(params);
}

@NgModule({
  declarations: [AppComponent, LoginComponent, SsoComponent, MaintenanceComponent, ConfirmComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgbPaginationModule,
    TranslateModule.forRoot({
      // Only in app.module.ts
      defaultLanguage: 'it',
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    ApiModule.forRoot(apiConfiguration),
    FlatpickrModule.forRoot(),
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbMessagesModule,
    QuillModule.forRoot(),
    ReactiveFormsModule,
    MatDialogModule,
    VideoPlayerModule,
  ],
  providers: [
    interceptorProviders,
    { provide: LOCALE_ID, useValue: 'it-IT' },
    CookieService,
    EnvServiceProvider,
    {
      provide: RouteReuseStrategy,
      useClass: CustomRouteReuseStrategy,
    },
    {
      provide: NgSelectConfig,
      useValue: {
        notFoundText: 'Nessun risultato',
        typeToSearchText: 'Cerca...',
        addTagText: 'Aggiungi',
        loadingText: 'Caricamento...',
        clearAllText: 'Cancella tutto',
      },
    },
    Title
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
